import { Flex } from '@mantine/core'
import { type Dispatch, memo, type SetStateAction } from 'react'

import { DatePickerInput, TimePickerInput } from '../../../../../src'
import { useDateTime } from '../../../hooks/useDateTime'
import {
  type FilterField,
  type FilterValue,
} from '../../multi-select/filterTypeConfig'

type DateTimeFilterWrapperProps = {
  selectedFilters: FilterValue[]
  setSelectedFilters: Dispatch<SetStateAction<FilterValue[]>>
  field: FilterField
}

export const DateTimeFilterWrapper = memo(
  ({
    selectedFilters,
    setSelectedFilters,
    field,
  }: Readonly<DateTimeFilterWrapperProps>) => {
    const { handleDateChange, handleTimeChange, getDateRange } = useDateTime(
      selectedFilters,
      setSelectedFilters
    )

    const isStart = field.key === 'start_at'
    const dateRange = getDateRange(isStart ? 'start_at' : 'end_at')
    const { startDate, startTime, endDate, endTime } = dateRange

    return (
      <Flex direction='column' gap='md'>
        <Flex data-testid='data-time-container' gap='md'>
          <DatePickerInput
            value={isStart ? startDate : endDate}
            onChange={(date) => {
              handleDateChange(isStart ? 'startDate' : 'endDate', date)
            }}
          />

          <TimePickerInput
            disabled={isStart ? !startDate : !endDate}
            value={isStart ? startTime : endTime}
            onChange={(time) => {
              handleTimeChange(isStart ? 'startTime' : 'endTime', String(time))
            }}
          />
        </Flex>
      </Flex>
    )
  }
)

DateTimeFilterWrapper.displayName = 'DateTimeFilterWrapper'
